import React, { useEffect } from 'react';
import { Row, Col, Nav } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import PayrollActivitiesTab from './payroll/PayrollActivitiesTab';
import PayrollUserConfigTab from './payroll/PayrollUserConfigTab';
import PayrollSettingsTab from './payroll/PayrollSettingsTab';
import PayrollPayoutsTab from './payroll/PayrollPayoutsTab';

const validTabs = ['activities', 'payouts', 'users', 'settings'];

const PayrollAdmin: React.FC = () => {
  const { tab } = useParams<{ tab: string }>();
  const navigate = useNavigate();
  const activeTab = tab && validTabs.includes(tab) ? tab : 'activities';

  useEffect(() => {
    if (!tab || !validTabs.includes(tab)) {
      navigate('/admin/payroll/activities', { replace: true });
    }
  }, [tab, navigate]);

  const stickyHeaderContent = (
    <Nav variant="tabs" className="mb-0">
      <Nav.Item>
        <Nav.Link active={activeTab === 'activities'} onClick={() => navigate('/admin/payroll/activities', { replace: true })}>
          Activities
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link active={activeTab === 'payouts'} onClick={() => navigate('/admin/payroll/payouts', { replace: true })}>
          Payouts
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link active={activeTab === 'users'} onClick={() => navigate('/admin/payroll/users', { replace: true })}>
          User Configuration
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link active={activeTab === 'settings'} onClick={() => navigate('/admin/payroll/settings', { replace: true })}>
          Pay Period Settings
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );

  return (
    <DashboardLayout
      title="Payroll"
      subtitle="Manage payroll activities, user configuration, and pay periods"
      stickyHeader={stickyHeaderContent}
      scrollable
    >
      <Row className="mb-4">
        <Col>
          {activeTab === 'activities' && <PayrollActivitiesTab />}
          {activeTab === 'payouts' && <PayrollPayoutsTab />}
          {activeTab === 'users' && <PayrollUserConfigTab />}
          {activeTab === 'settings' && <PayrollSettingsTab />}
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default PayrollAdmin;
